import React, { useState } from "react";
import Select from "react-select";
import { Card, Col, Label, Row, Input } from "reactstrap";
import { DatePicker, Tooltip } from "antd";
import dayjs from "dayjs";

import { CustomButton, showToast } from "components/Common";
import DownloadFile from "./DownloadFile";

import { ExportTestListDepartmentSites } from "../../helpers/app-backend/testlistdepartmentsitebackend_helper";

const { RangePicker } = DatePicker;

const Index = ({
  sites = [],
  error,
  setError,
  isLoading,
  filter,
  setFilter,
  paging,
  setPaging,
}) => {
  const [isExportFile, setIsExportFile] = useState(false);
  const [tempFilter, setTempFilter] = useState({});
  const [isDisableButton, setIsDisableButton] = useState(false);

  const handleInputChange = (field, value) => {
    setTempFilter(prev => ({ ...prev, [field]: value }));
  };

  const HandleSubmitSite = val => {
    const newSiteCode = val ? val.value : "";
    setFilter(prev => ({
      ...prev,
      siteCode: newSiteCode,
    }));
    setTempFilter(prev => ({
      ...prev,
      siteCode: newSiteCode,
    }));
    setPaging(prev => ({ ...prev, currentPage: 1 }));
  };

  const onChangeSubmitData = () => {
    if (!filter.siteCode && !tempFilter.siteCode) {
      showToast("Bạn phải chọn Site trước khi tìm kiếm", 2);
      return;
    }

    setFilter(prev => ({
      ...prev,
      ...tempFilter,
      siteCode: prev.siteCode || tempFilter.siteCode,
    }));

    setPaging(prev => ({ ...prev, currentPage: 1 }));
  };

  const getExportApi = () => ExportTestListDepartmentSites;

  const inputConfigs = [
    { label: "InstrumentID", key: "InstrumentID" },
    { label: "InstrumentName", key: "InstrumentName" },
    { label: "MasterInstrumentID", key: "MasterInstrumentID" },
    { label: "MasterInstrumentName", key: "MasterInstrumentName" },
    { label: "TestCode", key: "TestCode" },
    { label: "TestName", key: "TestName" },
    { label: "MasterTestcode", key: "MasterTestcode" },
    { label: "MasterTestName", key: "MasterTestName" },
    { label: "MasterCategory", key: "MasterCategory" },
  ];

  return (
    <Card className="p-3 mb-2">
      <Row>
        <Col sm={12} md={2} xl={2} style={{ zIndex: 1000 }}>
          <Label className="mb-1">SiteName</Label>
          <Select
            className="custom-select"
            isClearable
            options={sites}
            placeholder="Chọn bệnh viện"
            value={sites.find(x => x.value === filter.siteCode) || null}
            onChange={HandleSubmitSite}
            styles={{
              control: base => ({
                ...base,
                border: `1px solid ${
                  error?.siteName ? "red" : "rgb(206, 212, 218)"
                }`,
              }),
            }}
          />
        </Col>

        <Col sm={12} md={2} xl={2}>
          <Label className="mb-1">StatMonth</Label>
          <RangePicker
            picker="month"
            style={{ width: "100%", paddingBottom: 6, paddingTop: 6 }}
            placeholder={["From Month", "To Month"]}
            value={
              tempFilter.monthFrom && tempFilter.monthTo
                ? [
                    dayjs(tempFilter.monthFrom, "YYYY-MM"),
                    dayjs(tempFilter.monthTo, "YYYY-MM"),
                  ]
                : null
            }
            onChange={(dates, dateStrings) => {
              handleInputChange("monthFrom", dateStrings[0]);
              handleInputChange("monthTo", dateStrings[1]);
            }}
          />
        </Col>

        {inputConfigs.map((item, index) => (
          <Col
            sm={12}
            md={2}
            xl={2}
            key={item.key}
            className={index >= 2 ? "mt-2" : ""}
          >
            <Label className="mb-1">{item.label}</Label>
            <Input
              placeholder={item.label}
              value={tempFilter[item.key] || ""}
              onChange={e => handleInputChange(item.key, e.target.value)}
            />
          </Col>
        ))}

        <Col sm={12} md={2} xl={2} style={{ marginTop: 30 }}>
          <Tooltip title="Lọc">
            <CustomButton color="primary" onClick={onChangeSubmitData}>
              <div className="d-flex align-items-center">
                <i className="bx bx-search" style={{ fontSize: "1rem" }}></i>
                <p className="mb-0 mx-1">Lọc</p>
              </div>
            </CustomButton>
          </Tooltip>
          <Tooltip
            title={
              isDisableButton
                ? "Đang xuất file, vui lòng chờ"
                : "Xuất file Excel"
            }
          >
            <CustomButton
              color="success"
              onClick={() => setIsExportFile(true)}
              style={{ marginLeft: 5 }}
              disabled={isDisableButton}
            >
              <div className="d-flex align-items-center">
                <i
                  className="bx bx-cloud-download"
                  style={{ fontSize: "1rem" }}
                ></i>
                <p className="mb-0 mx-1">Excel</p>
              </div>
            </CustomButton>
          </Tooltip>
        </Col>
      </Row>

      {isExportFile && (
        <DownloadFile
          isOpen={isExportFile}
          isUseFilter
          request={filter}
          setIsDisableButton={setIsDisableButton}
          serviceApi={getExportApi()}
          onClose={() => setIsExportFile(false)}
          fileName={`Danh sách xét nghiệm khoa phòng trên site`}
        />
      )}
    </Card>
  );
};

export default Index;
